import React, { forwardRef, Fragment, useState } from "react"
import { FaEye, FaEyeSlash } from "react-icons/fa"
import clsx from "clsx"

import { CountDownTimer, Input } from "components"
import classes from "./TextField.module.scss"

const TextField = (props, ref) => {
  const {
    className = "",
    inputClassName = "",
    value = "",
    label = "",
    error,
    isAlphanumberic = false,
    initialTime,
    startIcon,
    type = "text",
    maxLength = -1,
    showMaxLength = false,
    isPassword = false,
    onTimeout = () => { },
    ...otherProps
  } = props

  const [showPassword, setShowPassword] = useState(false)

  const maxLengthReached =
    value.length === maxLength

  const showHeader =
    !!label || showMaxLength

  return (
    <div className={className}>
      {
        showHeader &&
        <div className={classes["row"]}>
          {
            !!label &&
            <label className={classes["label"]}>
              {label}
            </label>
          }
          {
            maxLength > 0 && showMaxLength &&
            <div
              className={clsx(
                maxLengthReached && classes["max-reached"]
              )}
            >
              {value.length} / {maxLength}
            </div>
          }
        </div>
      }
      <div className={classes["input-container"]}>
        <Input
          ref={ref}
          componentType="bootstrap"
          value={value}
          autoComplete="off"
          maxLength={maxLength}
          type={isPassword ? showPassword ? "text" : "password" : type}
          className={clsx(
            inputClassName,
            classes["input"],
            !!error && classes["input-error"],
            !!isPassword && classes["icon-padding"],
            isAlphanumberic && classes["direction"],
            !!initialTime && classes["timer-padding"],
            startIcon && classes["input-start-icon"]
          )}
          {...otherProps}
        />
        {
          isPassword &&
          <Fragment>
            {showPassword
              ?
              <FaEyeSlash
                className={classes["is-password"]}
                onClick={() => setShowPassword(prev => !prev)}
              />
              :
              <FaEye
                className={classes["is-password"]}
                onClick={() => setShowPassword(prev => !prev)}
              />
            }
          </Fragment>
        }
        {
          !!initialTime &&
          <div className={classes["timer"]}>
            <CountDownTimer
              zeroPads={{ seconds: true }}
              show={{ minutes: true, seconds: true }}
              onTimeout={onTimeout}
              initialTime={initialTime}
              inSeconds
            />
          </div>
        }
      </div>
      {
        !!error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default forwardRef(TextField)